import * as React from "react";
import { InputMask } from "primereact/inputmask";

export const TextMask = ({ column, value, handleChange, disabled }) => (
	// @ts-ignore
	// TODO!!!
	<InputMask
		value={value}
		disabled={disabled}
		mask={column?.extra?.mask ?? "99/99/9999"}
		placeholder={column?.extra?.mask ?? "99/99/9999"}
		onChange={(event) => handleChange(event.value)}
	/>
);
